import { StatusType } from '../Status'

export enum FilesKind {
  OTHER = 'other',
  /* ----------------------------------- ID ----------------------------------- */
  PROOF_OF_ID = 'proof_of_id',
  PROOF_OF_ID_IDENTITY_CARD = 'proof_of_id_identity_card',
  PROOF_OF_ID_PASSPORT = 'proof_of_id_passport',
  PROOF_OF_ID_DRIVING_LICENCE = 'proof_of_id_driving_licence',
  PROOF_OF_ID_RESIDENCE_PERMIT = 'proof_of_id_residence_permit',
  PROOF_OF_ID_TEMPORARY_STAY = 'proof_of_id_temporary_stay',
  PROOF_OF_ID_EU_CARD = 'proof_of_id_eu_card',

  /* --------------------------- PROOF OF RESIDENCE --------------------------- */
  PROOF_OF_RESIDENCE_RENT = 'proof_of_residence_rent',
  PROOF_OF_RESIDENCE_HOSTED = 'proof_of_residence_hosted',
  PROOF_OF_RESIDENCE_ELECTION = 'proof_of_residence_election',
  PROOF_OF_RESIDENCE_OWNER = 'proof_of_residence_owner',

  /* ------------------------------ PROOF OF WORK ----------------------------- */
  PROOF_OF_WORK_STUDENT_CARD = 'proof_of_work_student_card',
  PROOF_OF_WORK_STUDENT_CERTIFICATE = 'proof_of_work_student_certificate',
  PROOF_OF_WORK_CONTRACT = 'proof_of_work_contract',
  PROOF_OF_WORK_CERTIFICATE = 'proof_of_work_certificate',
  PROOF_OF_WORK_INSEE = 'proof_of_work_insee',
  PROOF_OF_WORK_URSSAF = 'proof_of_work_urssaf',
  PROOF_OF_WORK_PRO_CARD = 'proof_of_work_pro_card',
  PROOF_OF_WORK_D1_EXTRACT = 'proof_of_work_d1_extract',
  PROOF_OF_WORK_K_EXTRACT = 'proof_of_work_k_extract',
  PROOF_OF_WORK_RETIREMENT = 'proof_of_work_retirement',
  PROOF_OF_WORK_BENEFITS = 'proof_of_work_benefits',
  PROOF_OF_WORK_RSA = 'proof_of_work_rsa',
  PROOF_OF_WORK_ANY = 'proof_of_work_any',

  /* ---------------------------- PROOF OF REVENUE ---------------------------- */
  PROOF_OF_REVENUE_INTERN = 'proof_of_revenue_intern',
  PROOF_OF_REVENUE_SALARY = 'proof_of_revenue_salary',
  PROOF_OF_REVENUE_BALANCE = 'proof_of_revenue_balance',
  PROOF_OF_REVENUE_BENEFITS = 'proof_of_revenue_benefits',
  PROOF_OF_REVENUE_ANY = 'proof_of_revenue_any',

  /* ------------------------------- TAX NOTICE ------------------------------- */
  TAX_NOTICE = 'tax_notice',
}

export const KindTranslate: { [key in FilesKind]: string } = {
  [FilesKind.OTHER]: 'Autres',

  [FilesKind.PROOF_OF_ID]: "Pièce d'identité",
  [FilesKind.PROOF_OF_ID_IDENTITY_CARD]:
    "Carte d'identité française ou étrangère (avec photo - recto verso)",
  [FilesKind.PROOF_OF_ID_PASSPORT]: 'Passeport français ou étranger (avec photo)',
  [FilesKind.PROOF_OF_ID_DRIVING_LICENCE]: 'Permis de conduire français ou étranger (avec photo)',
  [FilesKind.PROOF_OF_ID_RESIDENCE_PERMIT]: 'Carte de résident',
  [FilesKind.PROOF_OF_ID_TEMPORARY_STAY]: 'Carte de séjour temporaire',
  [FilesKind.PROOF_OF_ID_EU_CARD]: "Carte de ressortissant d'un État membre de l'UE ou de l'EEE",

  [FilesKind.PROOF_OF_RESIDENCE_RENT]: 'Quittance de loyer',
  [FilesKind.PROOF_OF_RESIDENCE_HOSTED]: "Attestation d'hébergement",
  [FilesKind.PROOF_OF_RESIDENCE_ELECTION]: "Attestation d'élection de domicile",
  [FilesKind.PROOF_OF_RESIDENCE_OWNER]: 'Dernière taxe foncière',

  [FilesKind.PROOF_OF_WORK_STUDENT_CARD]: "Carte d'étudiant",
  [FilesKind.PROOF_OF_WORK_STUDENT_CERTIFICATE]: 'Certificat de scolarité à jour',
  [FilesKind.PROOF_OF_WORK_CONTRACT]: 'Contrat de travail',
  [FilesKind.PROOF_OF_WORK_CERTIFICATE]: 'Attestation employeur',
  [FilesKind.PROOF_OF_WORK_INSEE]: "Certificat d'identification de l'Insee",
  [FilesKind.PROOF_OF_WORK_URSSAF]: 'Attestation URSSAF auto-entrepreneur',
  [FilesKind.PROOF_OF_WORK_PRO_CARD]: 'Copie de la carte professionnelle',
  [FilesKind.PROOF_OF_WORK_ANY]: '',
  [FilesKind.PROOF_OF_WORK_D1_EXTRACT]: 'Extrait D1 original de moins de 3 mois',
  [FilesKind.PROOF_OF_WORK_K_EXTRACT]: 'Extrait K ou K bis de moins de 3 mois',
  [FilesKind.PROOF_OF_WORK_RETIREMENT]: "Dernier décompte d'arrérages ou notification de retraite",
  [FilesKind.PROOF_OF_WORK_BENEFITS]: 'Attestation de chômage',
  [FilesKind.PROOF_OF_WORK_RSA]: 'Attestation de RSA',

  [FilesKind.PROOF_OF_REVENUE_INTERN]: 'Justificatif de versement des indemnités',
  [FilesKind.PROOF_OF_REVENUE_SALARY]: 'Bulletin de salaire',
  [FilesKind.PROOF_OF_REVENUE_BALANCE]: "Bilan d'activité comptable",
  [FilesKind.PROOF_OF_REVENUE_BENEFITS]: 'Justificatif de versement des indemnités',
  [FilesKind.PROOF_OF_REVENUE_ANY]: '',

  [FilesKind.TAX_NOTICE]: "Dernier avis d'imposition",
}

export const KindDescription: { [key in FilesKind]: string } = {
  [FilesKind.OTHER]: 'Autre',
  [FilesKind.PROOF_OF_ID]: "Carte d'identité, Passeport, Permis de conduire...",
  [FilesKind.PROOF_OF_ID_IDENTITY_CARD]: "Carte d'identité",
  [FilesKind.PROOF_OF_ID_PASSPORT]: 'Passeport',
  [FilesKind.PROOF_OF_ID_DRIVING_LICENCE]: 'Permis de conduire',
  [FilesKind.PROOF_OF_ID_RESIDENCE_PERMIT]: 'Carte de résident',
  [FilesKind.PROOF_OF_ID_TEMPORARY_STAY]: 'Carte de séjour',
  [FilesKind.PROOF_OF_ID_EU_CARD]: 'Carte membre UE',
  [FilesKind.PROOF_OF_RESIDENCE_RENT]: 'Quittance',
  [FilesKind.PROOF_OF_RESIDENCE_HOSTED]: "Attestation d'hébergement",
  [FilesKind.PROOF_OF_RESIDENCE_ELECTION]: '',
  [FilesKind.PROOF_OF_RESIDENCE_OWNER]: 'Taxe foncière',
  [FilesKind.PROOF_OF_WORK_STUDENT_CARD]: "Carte d'étudiant",
  [FilesKind.PROOF_OF_WORK_STUDENT_CERTIFICATE]: 'Certificat de scolarité à jour',
  [FilesKind.PROOF_OF_WORK_CONTRACT]: 'Contrat de travail',
  [FilesKind.PROOF_OF_WORK_CERTIFICATE]: 'Attestation employeur',
  [FilesKind.PROOF_OF_WORK_INSEE]: "Certificat d'identification de l'Insee",
  [FilesKind.PROOF_OF_WORK_URSSAF]: 'Attestation URSSAF auto-entrepreneur',
  [FilesKind.PROOF_OF_WORK_PRO_CARD]: 'Copie de la carte professionnelle',
  [FilesKind.PROOF_OF_WORK_ANY]: '',
  [FilesKind.PROOF_OF_WORK_D1_EXTRACT]: 'Extrait D1 original de moins de 3 mois',
  [FilesKind.PROOF_OF_WORK_K_EXTRACT]: 'Extrait K ou K bis de moins de 3 mois',
  [FilesKind.PROOF_OF_WORK_RETIREMENT]: "Dernier décompte d'arrérages ou notification de retraite",
  [FilesKind.PROOF_OF_WORK_BENEFITS]: 'Attestation de chômage',
  [FilesKind.PROOF_OF_WORK_RSA]: 'Attestation de RSA',
  [FilesKind.PROOF_OF_REVENUE_INTERN]: 'Justificatif de versement des indemnités',
  [FilesKind.PROOF_OF_REVENUE_SALARY]: 'Bulletin de salaire',
  [FilesKind.PROOF_OF_REVENUE_BALANCE]: "Bilan d'activité comptable",
  [FilesKind.PROOF_OF_REVENUE_BENEFITS]: 'Justificatif de versement des indemnités',
  [FilesKind.PROOF_OF_REVENUE_ANY]: '',
  [FilesKind.TAX_NOTICE]: "Dernier avis d'imposition",
}

export const KindStatusTranslate: { [key in StatusType]: string } = {
  [StatusType.WARNING]: 'pièce(s) manquante(s)',
  [StatusType.ERROR]: 'pièce(s) à remplacer',
  [StatusType.SUCCESS]: 'pièce(s) validée(s)',
  [StatusType.WAITING]: 'en attente de l’agence',
  [StatusType.IDLE]: '',
}
